import React, { useEffect, useState, useContext } from "react";
import Socket from "../../../../context/SocketContext";
import { getOnlineDuration } from "./timeAgo";

// Mapping types to readable labels
const ROLE_MAP = {
  1: { label: "Admin", color: "#e74c3c" },
  2: { label: "Super", color: "#9b59b6" },
  3: { label: "Master", color: "#3498db" },
  4: { label: "User", color: "#2ecc71" },
  5: { label: "Broker", color: "#f1c40f" },
  6: { label: "Sub-Broker", color: "#e67e22" },
  7: { label: "S-Sub-Broker", color: "#34495e" },
};

export default function ActiveUserModal({ open, close }) {
  const socket = useContext(Socket);
  const [users, setUsers] = useState([]);
  const [tick, setTick] = useState(0);

  // Live timer tick
  useEffect(() => {
    const interval = setInterval(() => setTick((t) => t + 1), 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (!socket) return;

    const handleReload = (payload) => {
      // The backend emits { users: [], counts: {} }
      setUsers(payload.users || []);
    };
    // Listen for the reload event
    socket.on("userreload", handleReload);
    return () => socket.off("userreload", handleReload);
  }, [open, socket]);

  if (!open) return null;

  return (
    <div style={styles.overlay} onClick={close}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div style={styles.header}>
          <h2>Active Users ({users.length})</h2>
          <button onClick={close} style={styles.closeX}>&times;</button>
        </div>

        <div style={styles.tableWrapper}>
          <table style={styles.table}>
            <thead>
              <tr style={styles.theadRow}>
                <th style={styles.th}>ID</th>
                <th style={styles.th}>Role</th>
                <th style={styles.th}>Server</th>
                <th style={styles.th}>Username</th>
                <th style={styles.th}>Online Duration</th>
                <th style={styles.th}>IP Address</th>
                <th style={styles.th}>Location</th>
                <th style={styles.th}>Device</th>
              </tr>
            </thead>

            <tbody>
              {users.length > 0 ? (
                users.map((u) => (
                  <tr key={u.id} style={styles.tr}>
                    <td style={styles.td}>{u.id}</td>
                    <td style={styles.td}>
                      <span style={{ 
                        ...styles.badge, 
                        backgroundColor: ROLE_MAP[u.type]?.color || "#95a5a6" 
                      }}>
                        {ROLE_MAP[u.type]?.label || "Unknown"}
                      </span>
                    </td>
                    <td style={{ ...styles.td, fontWeight: "bold" }}>{u.server}</td>
                    <td style={{ ...styles.td, fontWeight: "bold" }}>{u.username}</td>
                    <td style={{ ...styles.td, color: "#2980b9" }}>
                      {getOnlineDuration(u.loginTime)}
                    </td>
                    <td style={styles.td}>{u.ip}</td>
                    <td style={styles.td}>
                      {u.city ? `${u.city}, ${u.country}` : "Detecting..."}
                    </td>
                    <td style={styles.td}>
                      <small>{u.os} - {u.browser}</small>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" style={{ ...styles.td, textAlign: "center", padding: 40 }}>
                    No users currently online
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <button onClick={close} style={styles.closeBtn}>Close Dashboard</button>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
    background: "rgba(0,0,0,0.7)", display: "flex", justifyContent: "center",
    alignItems: "center", zIndex: 9999, backdropFilter: "blur(4px)"
  },
  modal: {
    width: "90%", maxWidth: "1100px", maxHeight: "85%", background: "#fff",
    borderRadius: 12, padding: "25px", overflow: "hidden", display: "flex", flexDirection: "column",
    boxShadow: "0 10px 30px rgba(0,0,0,0.3)"
  },
  header: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 },
  closeX: { background: "none", border: "none", fontSize: 28, cursor: "pointer" },
  tableWrapper: { overflowY: "auto", flex: 1, border: "1px solid #eee", borderRadius: 8 },
  table: { width: "100%", borderCollapse: "collapse", fontSize: "14px" },
  theadRow: { background: "#f8f9fa", position: "sticky", top: 0, zIndex: 1 },
  th: { padding: "12px 15px", textAlign: "left", borderBottom: "2px solid #dee2e6", color: "#444" },
  td: { padding: "12px 15px", borderBottom: "1px solid #eee", verticalAlign: "middle" },
  tr: { hover: { background: "#f1f1f1" } },
  badge: { padding: "4px 8px", borderRadius: 4, color: "white", fontSize: "11px", fontWeight: "bold", textTransform: "uppercase" },
  closeBtn: { marginTop: 20, alignSelf: "flex-end", padding: "10px 25px", background: "#000", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer" }
};